import type { ICustomControlRequestReadProps } from '../../../interfaces/customControlRequestReadProps';
import { translateKey } from '../../../../../../translate';
import { UserTextParagraph } from '../../../../../elements/common';
import { FormLabel } from '../../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../../elements/forms/InputContainer';
import { RequestThumbnails } from '../../../utils/v1/RequestThumbnails';

export function PilotConsultationV1RequestSummary(props: ICustomControlRequestReadProps) {
    const question =
        props.request.customControlData && props.request.customControlData.vraag
            ? props.request.customControlData.vraag
            : props.request.question;

    return (
        <>
            <RequestThumbnails {...props} />

            {props.request.customControlData?.werkdiagnose && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('diagnosis.workingDiagnosis')}</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.request.customControlData.werkdiagnose}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {question && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('request.question')}</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{question}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
